import React from 'react';
import {filteredNodesAtom} from "../../atoms/atoms";
import {useAtom} from "jotai";
import Result from './Result';
import styled from "styled-components/macro";
import colors from "../../styles/variables/colors";

type CategorizedResultComponent = () => JSX.Element;

const ColumnWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0,1fr));
  gap: 30px;
  @media (min-width: 1024px) {
    gap: 5px;
    grid-template-columns: repeat(3, minmax(0,1fr));
  }
`;

const ColumnTitle = styled.span`
  color: ${colors.slate.base};
  font-family: 'Helvetica Now Text W01 Bold', sans-serif;
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 10px;
  display: inline-block;
`;

const NodeBubbleWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  @media (min-width: 1024px) {
    flex-wrap: no-wrap;
    gap: 0;
  }
`;

const CategorizedResult: CategorizedResultComponent = () => {

  const [nodes] = useAtom(filteredNodesAtom);
  const categories = Array.from(new Set(nodes.map(node => {return node.adFormat})));

  const NodesByCategory = ({category}: { category: string }) => {
    const categorizedNodes = nodes.filter(node => node.adFormat === category);
    return (
      <>
        <ColumnTitle>{category} ({categorizedNodes.length})</ColumnTitle>
        <NodeBubbleWrap>
          {
            categorizedNodes && categorizedNodes.map(node => {
              return <Result node={node} key={`node:result:${node.id}`}/>
            })
          }
        </NodeBubbleWrap>
      </>
    );
  }

  return (
    <ColumnWrapper>{
      categories.map(category => {
        return (
          <div key={`category:block:${category}`}>
            <NodesByCategory category={category}/>
          </div>
        )
      })
    }</ColumnWrapper>
  )
}
export default CategorizedResult;
